export const NotificationsConfig = {
  dismiss: true,
  dismissAfter: 5000
};

export type NotificationsStatus =
  | "default"
  | "info"
  | "success"
  | "warning"
  | "error";

export function notifyDefault(title, message) {
  return {
    title,
    message,
    status: "default",
    dismissible: NotificationsConfig.dismiss,
    dismissAfter: NotificationsConfig.dismissAfter
  };
}

export function notifySuccess(title: string, message: string, dismissAfter?: number) {
  return {
    title,
    message,
    status: "success",
    dismissible: NotificationsConfig.dismiss,
    dismissAfter: dismissAfter !== undefined ? dismissAfter : NotificationsConfig.dismissAfter
  };
}

export function notifyDanger(title, message) {
  return {
    title,
    message,
    status: "error",
    dismissible: NotificationsConfig.dismiss,
    dismissAfter: NotificationsConfig.dismissAfter
  };
}

export function notifyInfo(title, message) {
  return {
    title,
    message,
    status: "info",
    dismissible: NotificationsConfig.dismiss,
    dismissAfter: NotificationsConfig.dismissAfter
  };
}

export function notifyWarning(title, message) {
  return {
    title,
    message,
    status: "warning",
    dismissible: NotificationsConfig.dismiss,
    dismissAfter: NotificationsConfig.dismissAfter
  };
}
